import { SxProps } from "@mui/material";

export const sxFeatureCard: SxProps = {
    borderRadius: '10px',
    textTransform: 'none',
    backgroundColor: '#FFF',
    boxShadow: '0px 4px 8px 0px rgba(0, 0, 0, 0.08)',
    color: 'rgba(0, 0, 0, 0.08)',
    '&:hover': {
        boxShadow: '0px 4px 50px 0px',
        backgroundColor: '#FFF'
    }
}